import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import {
  FDListItem,
  FDListItemSecondary,
  FDListItemText,
  FDSecondaryActionIconButton,
} from '@facet-wealth/design';

export const CashFlowItem = ({ lineItemResource, onEditClick, index }) => {
  const onClick = lineItemResource.withRelationship(
    fr.relationships.item.name,
    (rel) => () => onEditClick(rel),
    () => undefined,
  );

  return (
    <FDListItem>
      <FDListItemText
        primaryText={lineItemResource.attr('name')}
        secondaryText={lineItemResource.attr('value')}
      />
      {onClick ? (
        <FDListItemSecondary>
          <FDSecondaryActionIconButton
            icon="edit"
            onClick={onClick}
            data-test={`cash-flow-item-edit-${index}`}
          />
        </FDListItemSecondary>
      ) : null}
    </FDListItem>
  );
};

CashFlowItem.propTypes = {
  lineItemResource: PropTypes.object.isRequired,
  onEditClick: PropTypes.func.isRequired,
  index: PropTypes.number.isRequired,
};
